import { Container, Flex, Modal, Radio, Text, Textarea } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { backendUrl } from "../../constants";
import Button from "../Button";

const Index = ({ opened, setOpened, setApplied, jobId }) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [resumes, setResumes] = useState([]);
  const [applyData, setApplyData] = useState({
    documnetId: "",
    coverLetter: "",
    user: createdBy?.id,
    jobId: jobId,
  });
  console.log("jobID", jobId);
  //resumes
  useEffect(() => {
    setResumes([]);
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}user/getJobSeekerDetails/${createdBy.id}`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data[0]?.jobSeeker[0]?.jobSeekerDocuments
          .filter((e) => e.documentType?.lookupName === "Resume")
          .map((e) => {
            setResumes((r) => [
              ...r,
              {
                documentName: e.documentName,
                document: e.document,
                id: e._id,
              },
            ]);
          });
      })
      .catch((err) => console.error(err));
  }, [createdBy?.id]);
  const handleApply = () => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(applyData),
    };
    fetch(`${backendUrl}job/applyForJob`, options)
      .then((response) => response.json())
      .then((response) => {
        showNotification({
          message: "You have successfuly applied for this job.",
          color: "green",
        });
        setApplied(true);
        handleClose();
      })
      .catch((err) => console.error(err));
  };

  const handleClose = () => {
    setOpened(false);
    setApplyData({ user: createdBy.id, jobId: jobId });
  };

  return (
    <>
      <Modal opened={opened} centered onClose={handleClose} title="Apply ">
        <Container>
          {resumes.length > 0 ? (
            <Radio.Group
              name="Select Resume"
              label="Select Resume"
              //   value={value}
              color="red"
              onChange={(e) => {
                setApplyData((v) => ({
                  ...v,
                  documnetId: e,
                }));
              }}
            >
              {resumes.map((e) => (
                <Radio
                  value={e.id}
                  label={e.documentName}
                  key={e?.id}
                  color="red"
                  //   checked={value === e.id}
                />
              ))}
            </Radio.Group>
          ) : (
            <Text className="text-dark text-center">
              No resume found! <br />
              Please upload your resume in profile Setting.
            </Text>
          )}
          <Textarea
            rows={4}
            label="Cover Letter"
            onChange={(v) =>
              setApplyData((e) => ({ ...e, coverLetter: v.target.value }))
            }
          />
          <Flex gap={5} justify={"flex-end"} className="mt-2">
            <Button title="Cancel" onClick={handleClose} />
            <Button
              title="Apply"
              primary={true}
              onClick={handleApply}
              disable={!applyData.documnetId}
            />
          </Flex>
        </Container>
      </Modal>
    </>
  );
};
export default withTranslation()(Index);
